export default "/images/86e60c100f3800ea0e51bde9ca24d6fd.avif";